(function($) {

    var $paginationHolder = $('.member-pagination'),
        $resultsList = $('#member-grid'),
        $searchInput = $('input[type="search"]');  // Get the search input directly

    // Pagination click handler
    $paginationHolder.on('click', 'a', function(e) {
        e.preventDefault();
        gatherVars($(this).text());
    });

    // Add input handler
    $searchInput.on('input', function() {
        // console.log('Search term:', $(this).val()); // Debug log
        gatherVars(1);
    });

    function gatherVars(page = 1) {
        var memberLink = $resultsList.attr('data-member-link'),
            searchTerm = $searchInput.val();

        // console.log('Sending search:', searchTerm); // Debug log

        triggerFilter("", memberLink, page, searchTerm);
    }

    function triggerFilter(category = "", memberLink = false, page = 1, search = "") {
        // console.log('Making AJAX request with:', {category, memberLink, page, search}); // Debug log

        $.post(ajax_global.url, {
            action: "member_filter",
            category: category,
            memberLink: memberLink,
            page: page,
            search: search
        }).done(function(r) {
            if (r.success) {
                // console.log('Response:', r); // Debug log
                pagination = r.data.pagination;
                posts = r.data.posts;

                $resultsList.html(posts);
                $paginationHolder.each(function() {
                    $(this).html(pagination);
                });

                $('html, body').animate({
                    scrollTop: $('#member-grid').offset().top
                }, 0);
            }
        });
    }

}(jQuery));